import type React from "react";
import { type RouteObject, useRoutes } from "react-router-dom";
import { AssessmentPlayground } from "@/pages/AssessmentPlayground";
import { Home } from "@/pages/Home";
import { ProductExperience } from "@/pages/ProductExperience";
import { TheoryCore } from "@/pages/TheoryCore";
import { TrainingConfig } from "@/pages/TrainingConfig";

const routes: RouteObject[] = [
	{ path: "/", element: <ProductExperience /> },
	{ path: "/app", element: <ProductExperience /> },
	{ path: "/admin", element: <TrainingConfig /> },
	{ path: "/admin/questions", element: <Home /> },
	{ path: "/admin/training-config", element: <TrainingConfig /> },
	{ path: "/admin/assessment", element: <AssessmentPlayground /> },
	{ path: "/admin/theory", element: <TheoryCore /> },
	{ path: "/training-config", element: <TrainingConfig /> },
	{ path: "/assessment", element: <AssessmentPlayground /> },
	{ path: "/theory", element: <TheoryCore /> },
	{ path: "*", element: <div>404 - 页面未找到</div> },
];

export const AppRoutes: React.FC = () => useRoutes(routes);
